"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  login: '登入',
  logout: '登出',
  none: '無',
  undefined: '尚未定義',
  product_categories: '產品分類',
  all_categories: '所有分類',
  sort: '排序',
  select: '請選擇',
  keyword: '關鍵字',
  list: '列表',
  order: '訂單',
  order_id: '訂單編號',
  order_created: '訂單建立日期',
  order_content: '訂單內容',
  pieces_of_item: '個品項',
  cart_items: '購物車清單',
  item: '品項',
  spec: '規格',
  total: '總金額',
  subtotal: '小計',
  price_info: '金額資訊',
  product: '商品',
  fee: '加價',
  discount: '折扣',
  order_title: '我的訂單',
  order_info: '訂單資訊',
  order_status: '訂單狀態',
  order_note: '訂單備註',
  order_total: '訂單總額',
  order_quantity: '訂購數量',
  payment_type: '付款方式',
  payment_status: '金流狀態',
  buyer_info: '購買人資訊',
  buyer_name: '購買人姓名',
  buyer_phone: '購買人電話',
  buyer_email: '購買人信箱',
  buyer_address: '購買人地址',
  buyer_tel: '購買人市話',
  buyer_tel_ext: '分機號碼',
  receiver_info: '收件人資訊',
  receiver_name: '收件人姓名',
  receiver_phone: '收件人電話',
  receiver_email: '收件人信箱',
  receiver_address: '收件人地址',
  receiver_tel: '市話',
  invoice_info: '發票資訊',
  payment_logistics_section_title: '付款及運送方式',
  cart_empty_title: '您的購物車為空',
  shopping: '立刻購物去',
  back_products: '返回全部商品',
  return: '退貨',
  check_return_status: '查看退貨狀態',
  apply_return: '申請退貨',
  return_form: '退貨表單',
  return_reason: '退貨理由',
  return_status: '退貨狀態',
  edit_return_info_forbidden: '未開放修改退貨資訊',
  edit_return_info: '修改退貨資訊',
  return_response_title: '商家回覆',
  other_login_way: '或使用以下方法登入',
  login_error: '登入失敗，請重新嘗試',
  account: '帳號',
  password: '密碼',
  register_now: '立即註冊',
  no_account: '還沒有帳號',
  forgot_password: '忘記密碼',
  reset: '重新設定',
  enter_account: '請輸入帳號',
  enter_password: '請輸入密碼',
  all: '全部',
  monday: '一',
  tuesday: '二',
  wednesday: '三',
  thursday: '四',
  friday: '五',
  saturday: '六',
  sunday: '日'
};
exports.labels = labels;